export class TrainingType {
    constructor(
        public TrainingTypeId: string,
        public Name: string,
        public NameFr: string
    )
    {}
}
